import { ArrowRight } from "lucide-react";
import { Magnetic } from "@/components/fx/Magnetic";
import { scrollToId } from "@/lib/motion";

export const SectionCta = ({ label = "Richiedi una figura", testId = "section-cta", className = "mt-14" }) => (
  <div className={`flex ${className}`}>
    <Magnetic>
      <a href="#richiedi" onClick={(e) => { e.preventDefault(); scrollToId("richiedi"); }} className="rl-btn rl-btn-amber !h-14 !px-8 !text-base" data-testid={testId}>
        {label} <ArrowRight size={18} className="rl-arrow" />
      </a>
    </Magnetic>
  </div>
);
